import api from '@/services/api';

async function buildShortUrl(url) {
  return api().get(`external/tini-url?url=${url}`);
}

export default buildShortUrl;
